<template>
  <div class="section-new-order section-full">
    <form-order :title="$gettext('Create new order')"/>
  </div>
</template>

<script>
import FormOrder from '@/components/FormOrder.vue';
export default {
  name: 'NewOrder',
  components: {
    FormOrder,
  },
};
</script>
